<template>
    <el-main>
        <el-dialog title="提示"
                   v-model="dialogVisible"
                   width="30%">
            <div class="yearjifen">
                <span> 年份：</span>
                <el-input v-model="yeartable" placeholder="请输入年份,例：2020"></el-input>
            </div>
            <div class="yearjifen">
                <span> 类型：</span>
                <el-input v-model="typetable" placeholder="请输入类型,例：js"></el-input>
            </div>
            <el-checkbox v-model="delTips" style="padding-left: 20%;">
                我明白删除之后数据无法恢复
            </el-checkbox>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="tableDelete" :disabled="!delTips">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <div style="height:100%" v-loading.fullscreen.lock="loading">
            <div style="width: 100%; height: 88%" v-show="show">
                <div style="float: right; margin: 10px 20px 30px 0">
                    <el-button @click="dialogVisible = true" class="deletetable" :disabled="tabletdisable">删除单位表格</el-button>
                    <el-popover placement="top" :width="160" v-model:visible="visible">
                        <p>确定删除吗？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="divsDelete">确定</el-button>
                        </div>
                        <template #reference>
                            <el-button @click="visible = true"><i class="el-icon-delete el-icon--left"></i>删除单位</el-button>
                        </template>
                    </el-popover>
                </div>
                <div class="my-table">
                    <el-table :data="tableData"
                              ref="tableRef"
                              stripe
                              height="100%"
                              style="width: 100%"
                              :header-cell-style="headerCellStyle"
                              @selection-change="handleSelectionChange"
                              row-key="id"
                              :tree-props="{children: 'children'}"
                              @select="rowSelect"
                              @select-all="selectAll"
                              default-expand-all>
                        <el-table-column type="selection" width="55"> </el-table-column>
                        <el-table-column label="单位" prop="name" width="500"> </el-table-column>
                        <el-table-column label="科室" prop="parentName"> </el-table-column>
                        <el-table-column label="单位编码" prop="code" width="180">
                        </el-table-column>
                        <el-table-column label="操作">
                            <template #default="scope">
                                <el-button type="primary" size="samll" @click="handleClick(scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div style="width: 100%; height: 88%; display: flex; justify-content: center"
                 v-show="!show">
                <div style="margin-top: 200px">
                    <div class="aaa">
                        <div style="width: 200px">单位新名称:</div>
                        <el-input v-model="editDetail.name" placeholder="单位新名称"></el-input>
                    </div>
                    <div class="aaa">
                        <div style="width: 200px">新编码:</div>
                        <el-input v-model="editDetail.code" placeholder="单位新编码"></el-input>
                    </div>
                    <div class="aaa">
                        <div style="width: 200px">单位类型:</div>
                        <el-select v-model="editDetail.kind"
                                   placeholder="请选择"
                                   style="width: 100%">
                            <el-option v-for="item in kindoptions"
                                       :key="item.id"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="aaa">
                        <div style="width: 200px">单位类别</div>
                        <el-select v-model="editDetail.type"
                                   placeholder="请选择"
                                   style="width: 100%">
                            <el-option v-for="item in typeoptions"
                                       :key="item.id"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="aaa">
                        <div style="width: 200px">单位性质:</div>
                        <el-input v-model="editDetail.customKind" placeholder="单位性质"></el-input>
                    </div>
                    <div class="aaa">
                        <div style="width: 200px">所属科室:</div>
                        <div style="width: 100%">
                            <el-select v-model="editDetail.parentid"
                                       filterable
                                       placeholder="请选择"
                                       style="width: 100%">
                                <el-option v-for="item in options"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="aaa" v-if="editDetail.type != 2">
                        <div style="width: 200px">所属部门:</div>
                        <div style="width: 100%">
                            <el-select v-model="editDetail.bmid"
                                       filterable
                                       placeholder="请选择"
                                       style="width: 100%">
                              <el-option
                                v-for="item in bmoptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              />
                            </el-select>
                        </div>
                    </div>
                    <div class="button">
                        <el-button type="primary" @click="save">保存</el-button>
                        <el-button @click="goback">取消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-main>
</template>
<script>
    import { getDivs, divEdit, divDelete, divEmptyTable } from '@/api/div.js';
    export default {
        name: "dwlb",
        data() {
            return {
                yeartable: '',
                typetable: '',
                dialogVisible: false,
                tabletdisable: true,
                visible: false,
                loading: true,
                tableData: [],
                oldTableData: [],
                list: [],
                show: true,
                editDetail: {
                    id: "",
                    type: "",
                    kind: "",
                    name: "",
                    code: "",
                    parentid: "",
                    bmid: "",
                    customKind:''
                },
                options: [],
                bmoptions: [],
                kindoptions: [],
                typeoptions: [],
                childrenType: false, //判断是否存在children
                delTips:false
            };
        },
        mounted() {
            this.init();
        },
        created() {
        },
        methods: {
            cleanExprList(val){
                console.log(val)
            },
            //删除表格
            async tableDelete() {
                if (this.yeartable == '') {
                    this.$message({
                        type: 'error',
                        message: '年份不能为空！'
                    });
                    return false
                } else if (this.typetable == '') {
                    this.$message({
                        type: 'error',
                        message: '类型不能为空！'
                    });
                    return false

                }
                let flag = false
                //删除单位表格
                for (let i = 0; i < this.list.length; i++) {
                    let data = { id: this.list[i].id, year: this.yeartable, type: this.typetable }
                    let res = await divEmptyTable(data)
                    if (res.status == 0) {
                        flag = true
                    }
                }
                if (flag) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }
                this.dialogVisible = false
                this.yeartable = ''
                this.typetable = ''
                this.$refs.tableRef.clearSelection()

            },
            save() {
                this.loading = true;
                let arr = {
                    id: this.editDetail.id,
                    type: this.editDetail.type,
                }
                this.editDetail.bmid.length == 0 ? '' : arr.bmId = this.editDetail.bmid
                this.editDetail.kind.length == 0 ? '' : arr.kind = this.editDetail.kind
                this.editDetail.type.length == 0 ? '' : arr.type = this.editDetail.type
                this.editDetail.customKind.length == 0 ? '' : arr.customKind = this.editDetail.customKind
                this.editDetail.code.length == 0 ? '' : arr.code = this.editDetail.code
                this.editDetail.name.length == 0 ? '' : arr.name = this.editDetail.name
                this.editDetail.parentid.length == 0 ? '' : arr.parentid = this.editDetail.parentid
                if(this.editDetail.type == 0 && !this.editDetail.bmid){
                    this.$message.error('请选择所属部门!')
                    this.loading = false;
                }else{
                    divEdit(arr)
                    .then((res) => {
                        if (res.status == 0) {
                            this.$message.success("修改成功!");
                            this.goback();
                            this.init();
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
                }
            },
            goback() {
                this.editDetail.name = "";
                this.editDetail.code = "";
                this.editDetail.parentid = "";
                this.editDetail.bmid = "";
                this.editDetail.kind = "";
                this.editDetail.customKind = "";
                this.show = true;
                this.tableData = this.oldTableData;
            },
            handleSelectionChange(val) {
                this.list = val
                this.tabletdisable = this.list == '' ? true : false
            },
            reverse(array) { //反转数组
                var newArr = [];
                for (var i = array.length - 1; i >= 0; i--) {
                    newArr[newArr.length] = array[i];
                }
                return newArr;
            },
            async divsDelete() {
                let tableList = this.tableData;
                this.list = this.reverse(this.list)
                this.loading = true;
                for (let i = 0; i < this.list.length; i++) {
                    let res = await divDelete({ id: this.list[i].id });
                    if (res.status == 0) {
                        this.visible = false;
                        this.$message.success("已删除!");
                    }
                }
                this.init()
                this.tableData = tableList;
                this.loading = false;
            },
            headerCellStyle() {
                return { height: "90px", background: "#E5F2FF" };
            },
            handleClick(row) {
                this.show = false;
                this.editDetail.id = row.id;
                this.editDetail.type = row.type;
                this.editDetail.bmId = row.bm;
                this.oldTableData = this.tableData;
                this.tableData = [];
            },
            init() {
                getDivs().then(res => {
                    if (res.status == 0) {
                        res.divs.forEach(ele => { ele.children = [] })
                        for (let i = res.divs.length - 1; i >= 0; i--) {
                            if ((res.divs[i].bm)) {
                                let a = res.divs.find(item => item.id == res.divs[i].bm)
                                if (a) {
                                    a.children.push(res.divs[i])
                                    a.children.sort(function (a, b) {
                                        return a.autoid - b.autoid
                                    })
                                    res.divs.splice(i, 1)
                                    this.childrenType = true //如果有children,开关打开
                                }
                            }
                        }
                        res.divs.forEach(ele => {
                            if (ele.children.length == 0) {
                                delete ele.children
                            }
                        })
                        this.tableData = res.divs.filter((e) => e.type !== 1);
                        this.options = res.divs.filter((e) => e.type == 1);
                        this.bmoptions = res.divs.filter((e) => e.type == 2);
                        this.kindoptions = [{
                            label: '行政单位',
                            value: 0
                        }, {
                            label: '事业单位',
                            value: 1
                        }]
                        this.typeoptions = [{
                            label: '部门',
                            value: 2
                        }, {
                            label: '单位',
                            value: 0
                        }]
                    }
                    this.loading = false
                }).catch(err => {
                    this.loading = false
                })
            },
            rowSelect(selection, row) {
                if (!row.children) {
                    return
                }
                if (selection.some(el => { return row.id === el.id })) {
                    if (row.children) {
                        row.children.map(j => {
                            this.toggleSelection(j, true)
                        })
                    }
                } else {
                    if (row.children) {
                        row.children.map(j => {
                            this.toggleSelection(j, false)
                        })
                    }
                }
            },
            selectAll(selection) {
                if (!this.childrenType) {
                    return
                }
                // tabledata第一层只要有在selection里面就是全选
                const isSelect = selection.some(el => {
                    const tableDataIds = this.tableData.map(j => j.id)
                    return tableDataIds.includes(el.id)
                })
                // tableDate第一层只要有不在selection里面就是全不选
                const isCancel = !this.tableData.every(el => {
                    const selectIds = selection.map(j => j.id)
                    return selectIds.includes(el.id)
                })
                if (isSelect) {
                    selection.map(el => {
                        if (el.children) {
                            el.children.map(j => {
                                this.toggleSelection(j, true)
                            })
                        }
                    })
                }
                if (isCancel) {
                    this.tableData.map(el => {
                        if (el.children) {
                            el.children.map(j => {
                                this.toggleSelection(j, false)
                            })
                        }
                    })
                }
            },
            toggleSelection(row, select) {
                if (row) {
                    this.$nextTick(() => {
                        this.$refs.tableRef && this.$refs.tableRef.toggleRowSelection(row, select)
                    })
                }
            },
        },
    };
</script>
<style scoped>
    .yearjifen {
        width: 100%;
        margin-bottom: 10px;
        float: left;
    }

        .yearjifen span {
            width: 20%;
            text-align: center;
            line-height: inherit;
            line-height: 40px;
            float: left;
        }

        .yearjifen /deep/ .el-input {
            width: 80%;
            float: left;
        }

    .deletetable {
        margin-right: 10px;
    }

    .el-main {
        color: #333;
        height: 800px;
        margin-left: 5%;
        overflow: auto;
    }

    .my-table {
        width: 100%;
        height: 100%;
    }

    .jurisdiction {
        width: 100%;
        height: 80px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

        .jurisdiction .top {
            height: 50%;
            width: 100%;
            border-bottom: 1px solid #c9d5e0;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .jurisdiction .bottom {
            height: 50%;
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }

    .option {
        height: 80px;
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 55px !important;
        font-size: 20px !important;
        font-weight: 500 !important;
        font-family: fangsong !important;
    }

    .button {
        margin-top: 50px;
        display: flex;
        justify-content: center;
    }

    .aaa {
        display: flex;
        align-items: center;
        margin-bottom: 20px
    }
</style>
